var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('profileParts'),(!_vm.email)?_c('SMTPform',{attrs:{"callback":_vm.setEmail}}):_c('currentEmail',{attrs:{"email":_vm.email,"callback":_vm.setEmail}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }